import cn from 'classnames'
import React, { createRef } from 'react'

import { Accordion, Ref } from 'util/ui'

export default class ManagedAccordion extends React.PureComponent {
  constructor(props) {
    super(props)
    const { initiallyActive } = props
    this.state = {
      // triggers componentDidUpdate, use fromTitleToggle to prevent scroll on mount
      active: initiallyActive,
      fromTitleToggle: false,
    }
    this.accordionRef = createRef()
  }

  componentDidUpdate = () => {
    const {
      state: { active, fromTitleToggle } = {},
      accordionRef: { current } = {},
      props: { scrollIntoViewOnToggleActive } = {},
    } = this

    if (active && current && fromTitleToggle && scrollIntoViewOnToggleActive) {
      current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  doToggleActive = () => {
    this.setState({
      active: !this.state.active,
      fromTitleToggle: true,
    })
  }

  render() {
    const { active } = this.state
    const {
      children,
      className,
      titleClassName,
      collapsed,
      contentProps,
      title,
      titleProps,
      initiallyActive,
      scrollIntoViewOnToggleActive,
      ...rest
    } = this.props
    return (
      <Ref innerRef={this.accordionRef}>
        <Accordion className={cn(className, { collapsed })} {...rest}>
          <Accordion.Title
            active={active}
            content={title}
            onClick={this.doToggleActive}
            className={cn(titleClassName)}
          />
          <Accordion.Content active={active} {...contentProps}>
            {children}
          </Accordion.Content>
        </Accordion>
      </Ref>
    )
  }
}
